<script>
    import Spinner from './Spinner.svelte';
    import Cookies from 'js-cookie';

    export let disableGoogleSignup = false;

    export let product = undefined;
    export let coupon = undefined;

    //FORM
    let firstName = undefined;
    let lastName = undefined;
    let company = undefined;
    let email = undefined;
    let password = undefined;

    let signupPage = document.location.pathname;
    let visitorData = Cookies.get("casual_session");

    const localhost = false; //document.location.host === "localhost:5000";
    const configPath = localhost ? "http://localhost:8080/client/config" : "/client/config";

    const ERROR_MESSAGES = {
        'EmailAlreadyInSystem': 'There is already a user with this email.',
        'EmailVerificationSent': 'This email is waiting for confirmation. Check your mailbox for a letter from us.',
        'EmailVerificationPending': 'This email is waiting for confirmation. Check your mailbox for a letter from us.',
        'UserCreated': 'Check your mailbox for a letter from us.',
        'Completed': 'There is already a user with this email. <br/> Try <a href="https://app.casual.pm/">logging in</a> or <a href="https://app.casual.pm/guest/forgot-password">recover your password</a>.',
        'BadInput': 'Please fill the form.',
        'BadPassword': 'Password must be at least 6 characters long.',
        'AlreadyCompleted': 'There is already a user with this email. <br/> Try <a href="https://app.casual.pm/">logging in</a> or <a href="https://app.casual.pm/guest/forgot-password">recover your password</a>.',
        'GeneralError': 'Unexpected error happened during the registration. Please try again later.',
        'RegistrationClosed': 'Please try again later.',
        'GoogleAuthFailed': 'Unable to sign up with Google.'
    };

    // let firstName = "Test";
    // let lastName = "User";
    // let company = undefined;
    // let email = "test@vir.com.ua";
    // let password = "password";

    //GLOBAL
    let globalError = undefined;
    let retryTimer = undefined;

    //CONFIG
    let config = undefined;
    loadConfig();

    //UI STATE
    let processing = false;
    let errorStatus = undefined;
    let googleSignupLoaded = false;

    async function loadConfig() {
        try {
            let response = await window.fetch(configPath);
            let configResponse = JSON.parse(await response.text());
            if (retryTimer) {
                clearTimeout(retryTimer);
                retryTimer = undefined;
            }
            config = configResponse.config;
        } catch (e) {
            globalError = "Loading signup form...";
            retryTimer = setTimeout(loadConfig, 3000);
            return {};
        }
    }

    async function onSubmitForm(event) {
        if (window.cpmt && window.cpmt.noop) {
            window.cpmt.gaEvent('Signup', 'Submit', product);
            window.cpmt.mpEvent("Site Signup Submit", {"plan": product});
        }

        processing = true;

        const request = {
            "firstName": firstName,
            "lastName": lastName,
            "company": company,
            "email": email,
            "password": password,
            "product": product,
            "coupon": coupon
        };
        const result = await callSignup(request);
        if (!result["sessionKey"]) {
            const status = result["status"];
            errorStatus = status;
            processing = false;

            if (window.cpmt && window.cpmt.noop) {
                window.cpmt.gaEvent('Signup', 'FormError', status);
                window.cpmt.mpEvent("Site Signup Form Error", {"status": status});
            }
        } else {
            const sessionKey = result["sessionKey"];
            const userId = result["userId"];
            const workspaceId = result["destination"];
            const signinUrl = config['api'] + "client/user/session/join/" + encodeURI(sessionKey);

            identifyAndSendToApp(signinUrl, userId, workspaceId);
        }
    }

    function identifyAndSendToApp(url, userId, workspaceId) {

        //Track
        if (window.cpmt && window.cpmt.noop) {
            window.cpmt.gaEvent('Signup', 'Success', product);
            window.cpmt.gaId(userId);

            window.cpmt.mpId(userId, workspaceId);
            window.cpmt.mpId(email);
            window.cpmt.mpEvent("Site Signup Identified", {
                "userId": "${SignupResultObject.userId}",
                "plan": product
            });
        }
        //Send away
        setTimeout(function () {
            window.location.replace(url);
        }, 300);
    }

    async function callSignup(obj) {
        let response = await window.fetch(config['api'] + `client/user/register/signup`, {
            method: 'POST',
            body: JSON.stringify(obj),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    }

    async function callGoogleValidate(token, plan, coupon) {
        const url = new URL(config['api'] + `client/g/validate`),
                params = {token: token, plan: plan, coupon: coupon};
        Object.keys(params).forEach(key => params[key] && url.searchParams.append(key, params[key]));
        const response = await window.fetch(url);
        if (response.status == 200)
            return await response.text();
        else
            return 'GoogleAuthFailed';
    }

    async function googleClicked(evt) {
        evt.preventDefault();
        if (window.gapi) {
            processing = true;

            await window.gapi.load('auth2');

            if (window.cpmt && window.cpmt.noop) {
                window.cpmt.gaEvent('Signup', 'Google', product);
                window.cpmt.mpEvent("Site Signup Google", {"plan": product});
            }

            window.gapi.auth2.init({
                "client_id": config['gapiid'],
                "cookie_policy": "none"
            }).then(async function (auth) {
                const result = await auth.signIn();
                if (result.error) {
                    errorStatus = 'GoogleAuthFailed';
                    processing = false;

                    if (window.cpmt && window.cpmt.noop) {
                        window.cpmt.gaEvent('Signup', 'GoogleError', errorStatus);
                        window.cpmt.mpEvent("Site Signup Google Error", {"status": errorStatus});
                    }
                } else {
                    const validateResult = await callGoogleValidate(
                            result.getAuthResponse().id_token, product, coupon);
                    if (validateResult.toString().startsWith("https:")) {
                        const parts = validateResult.toString().split('\n')
                        const url = parts[0];
                        const id = parts[1];
                        identifyAndSendToApp(url, id);
                    } else {
                        errorStatus = validateResult;
                        processing = false;
                    }
                }

            }, function (error) {
                console.log("Error Initializing GAPI: " + JSON.stringify(error));
                errorStatus = 'GoogleAuthFailed';
                processing = false;
                if (window.cpmt && window.cpmt.noop) {
                    window.cpmt.gaEvent('Signup', 'GoogleInitError', errorStatus);
                    window.cpmt.mpEvent("Site Signup Google Init Error", {"status": errorStatus});
                }
            });
        }
        return false;
    }

    function loadGoogleSignup() {
        window.gapi && window.gapi.load('auth2', function () {
            googleSignupLoaded = true;
        });
    }

    if (!disableGoogleSignup) {
        window.addEventListener('load', loadGoogleSignup);
    }
</script>

<svelte:options tag="casual-signup-form"/>

<div>
    {#if !disableGoogleSignup}
        <script src="https://apis.google.com/js/platform.js" async defer></script>
    {/if}
    {#if config}
        <form on:submit|preventDefault="{onSubmitForm}" class="signup-form">
            <div class="signup-block">
                <div class="signup-form-inputs">
                    <input bind:value={firstName} type="text" size="18"
                           placeholder="First Name" aria-label="First Name" required
                           class="signup-form-input signup-form-input-half"/>
                    <input bind:value={lastName} type="text" size="18"
                           placeholder="Last Name" aria-label="Last Name" required
                           class="signup-form-input signup-form-input-half signup-lastname"/>
                    <input bind:value={company} type="text" size="18"
                           placeholder="Company or Organization" aria-label="Company or Organization"
                           class="signup-form-input"/>
                    <input bind:value={email} type="email" size="18"
                           placeholder="Your email" aria-label="Your email" required
                           class="signup-form-input"/>
                    <input bind:value={password} type="password" size="18"
                           placeholder="Password" aria-label="Password" required
                           class="signup-form-input"/>
                </div>

                {#if errorStatus}
                    <div class="signup-form-error">{@html ERROR_MESSAGES[errorStatus]}</div>
                {/if}

                {#if processing}
                    <button disabled class="signup-form-button signup-form-button-disabled">Please wait...</button>
                {:else}
                    <button class="signup-form-button">Start Free Trial</button>
                {/if}

                <div class="signup-form-note">By signing up, you agree to our
                    <a href="/terms" target="_blank" rel="noopener" class="signup-terms-link">Terms of Service</a>.
                </div>
                {#if !disableGoogleSignup && googleSignupLoaded && !processing}
                    <div class="signup-divider"></div>
                    <div class="signup-google-text">Or sign up with</div>
                    <div class="signup-google-button">
                        <a href="/" on:click={googleClicked}>
                            <img src="https://s.casual.pm/images/google_signup.png"
                                 srcset="https://s.casual.pm/images/google_signup@2x.png 2x"
                                 alt="Sign up with Google">
                        </a>
                    </div>
                {/if}
            </div>
        </form>
    {:else}
        <div class="signup-loader">
            {#if globalError}
                <div class="signup-global-error">{globalError}</div>
            {/if}
            <Spinner size="50" speed="750" color="#666" thickness="2" gap="40"/>
        </div>
    {/if}
</div>

<style>

</style>